require('./../css/style.css');

function initSearchResult() {
    const searchResult = document.querySelector(".js-search-result");
    if (!searchResult) {
        return;
    }

    const form = searchResult.querySelector(".js-search-result__form");
    if (!form) {
        return;
    }
    const state = {
        get skip() {
            return parseInt(form.querySelector(".js-search-result__skip").value);
        },
        set skip(val) {
            form.querySelector(".js-search-result__skip").value = val;
        },
        get take() {
            return parseInt(form.querySelector(".js-search-result__take").value);
        },
        get total() {
            return parseInt(form.querySelector(".js-search-result__total").value);
        },
        set count(val) {
            searchResult.querySelector(".js-search-result__count").innerHTML = val;
        }
    }
    const resultList = searchResult.querySelector(".js-search-result__list");

    function updateSkipValue() {
        state.skip = state.skip + state.take;

        checkMoreBtn();
    };

    form.submitCallback = () => {
        updateSkipValue();
    };

    form.successCallback = html => {
        resultList.insertAdjacentHTML("beforeend", html);
    };

    form.errorCallback = data => {
        alert(`Something wrong with respond ${data.message}`);
    };

    function checkMoreBtn() {
        if (state.skip >= state.total) {
            state.count = state.total;
            form.querySelector(".js-search-result__form-submit").remove();
        } else {
            state.count = state.skip;
        }
    }

    checkMoreBtn();
}

export default initSearchResult;


// WEBPACK FOOTER //
// ./uPortal/Core/Pages/SearchPage/Js/index.js